export const modules = [
    {
        name: "Bomb Scare",
        img: 'images/modules/MC01en_109.jpg',
        pack: "Core Set",
    },
    {
        name: "The Masters of Evil",
        img: 'images/modules/MC01en_128.jpg',
        pack: "Core Set",
    },
    {
        name: "Under Attack",
        img: 'images/modules/MC01en_151.jpg',
        pack: "Core Set",
    },
    {
        name: "The Legions of Hydra",
        img: 'images/modules/MC01en_180.jpg',
        pack: "Core Set",
    },
    {
        name: "The Doomsday Chair",
        img: 'images/modules/MC01en_183.jpg',
        pack: "Core Set",
    },
    {
        name: "Goblin Gimmicks",
        img: "images/modules/mc02en_card_goblin-glider.jpg",
        pack: "Green Goblin"
    },
    {
        name: "A Mess of Things",
        img: "images/modules/02037.jpg",
        pack: "Green Goblin"
    },
    {
        name: "Power Drain",
        img: "images/modules/02041.jpg",
        pack: "Green Goblin"
    },
    {
        name: "Running Interference",
        img: "images/modules/02046.jpg",
        pack: "Green Goblin"
    },
    {
        name: "Weapon Master",
        img: "images/modules/MC10en_148.jpg",
        pack: "The Rise of Red Skull",
    },
    {
        name: "Experimental Weapons",
        img: "images/modules/MC10en_72.jpg",
        pack: "The Rise of Red Skull",
    },
    {
        name: "Hydra Assault",
        img: "images/modules/MC10en_145.jpg",
        pack: "The Rise of Red Skull",
    },
    {
        name: "Hydra Patrol",
        img: "images/modules/MC10en_152.jpg",
        pack: "The Rise of Red Skull",
    },
    {
        name: "Anachronauts",
        img: "images/modules/MC11en_40.jpg",
        pack: "The Once and Future Kang",
    },
    {
        name: "Master of Time",
        img: "images/modules/MC11en_47.jpg",
        pack: "The Once and Future Kang",
    },
    {
        name: "Temporal",
        img: "images/modules/MC11en_30.jpg",
        pack: "The Once and Future Kang",
    },
    {
        name: "Kree Fanatic",
        img: "images/modules/gen_con_2020_ronan.jpg",
        pack: "Ronan the Accuser (Print and Play)",
    },
    {
        name: "Band of Badoon",
        img: "images/modules/MC16en_117.jpg",
        pack: "Galaxy's Most Wanted",
    },
    {
        name: "Galactic Artifacts",
        img: "images/modules/MC16en_122.jpg",
        pack: "Galaxy's Most Wanted",
    },
    {
        name: "Kree Militants",
        img: "images/modules/MC16en_131.jpg",
        pack: "Galaxy's Most Wanted",
    },
    {
        name: "Menagerie Medley",
        img: "images/modules/MC16en_135.jpg",
        pack: "Galaxy's Most Wanted",
    },
    {
        name: "Space Pirates",
        img: "images/modules/MC16en_138.jpg",
        pack: "Galaxy's Most Wanted",
    },
    {
        name: "Power Stone",
        img: "images/modules/power-stone.jpg",
        pack: "Galaxy's Most Wanted",
        randomize: false,
    },
    {
        name: "Ship Command",
        img: "images/modules/ship-command.png",
        pack: "Galaxy's Most Wanted",
        randomize: false,
    },
    {
        name: "The Black Order",
        img: "images/modules/MC21en_85.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Armies of Titan",
        img: "images/modules/MC21en_89.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Children of Thanos",
        img: "images/modules/MC21en_125.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Infinity Gauntlet",
        img: "images/modules/MC21en_129.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Legions of Hel",
        img: "images/modules/MC21en_152.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Frost Giants",
        img: "images/modules/MC21en_156.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Enchantress",
        img: "images/modules/MC21en_177.jpg",
        pack: "The Mad Titan's Shadow",
    },
    {
        name: "Beasty Boys",
        img: "images/modules/MC24en_14.jpg",
        pack: "The Hood",
    },
    {
        name: "Brothers Grimm",
        img: "images/modules/MC24en_18.jpg",
        pack: "The Hood",
    },
    {
        name: "Crossfire's Crew",
        img: "images/modules/MC24en_23.jpg",
        pack: "The Hood",
    },
    {
        name: "Mister Hyde",
        img: "images/modules/MC24en_33.png",
        pack: "The Hood",
    },
    {
        name: "Ransacked Armory",
        img: "images/modules/MC24en_37.png",
        pack: "The Hood",
    },
    {
        name: "Sinister Syndicate",
        img: "images/modules/MC24en_42.jpg",
        pack: "The Hood",
    },
    {
        name: "State of Emergency",
        img: "images/modules/MC24en_55.jpg",
        pack: "The Hood",
    },
    {
        name: "Streets of Mayhem",
        img: "images/modules/MC24en_60.jpg",
        pack: "The Hood",
    },
    {
        name: "Wrecking Crew",
        img: "images/modules/MC24en_64.jpg",
        pack: "The Hood",
    },
    {
        name: "City in Chaos",
        img: "images/modules/city-in-chaos.png",
        pack: "Sinister Motives",
    },
    {
        name: "Down to Earth",
        img: "images/modules/down-to-earth.png",
        pack: "Sinister Motives",
    },
    {
        name: "Goblin Gear",
        img: "images/modules/goblin-gear.png",
        pack: "Sinister Motives",
    },
    {
        name: "Guerrilla Tactics",
        img: "images/modules/guerrilla-tactics.png",
        pack: "Sinister Motives",
    },
    {
        name: "Osborn Tech",
        img: "images/modules/osborn-tech.png",
        pack: "Sinister Motives",
    },
    {
        name: "Personal Nightmare",
        img: "images/modules/personal-nightmare.png",
        pack: "Sinister Motives",
    },
    {
        name: "Sinister Assault",
        img: "images/modules/sinister-assault.png",
        pack: "Sinister Motives",
    },
    {
        name: "Symbiotic Strength",
        img: "images/modules/symbiotic-strength.png",
        pack: "Sinister Motives",
    },
    {
        name: "Whispers of Paranoia",
        img: "images/modules/whispers-of-paranoia.png",
        pack: "Sinister Motives",
    },
    {
        name: "Armadillo",
        img: "images/modules/mc28_nova_cardsingles__armadillo.png",
        pack: "Nova",
    },
    {
        name: "Zzzax",
        img: "images/modules/mc29en_feedback_loop_36.png",
        pack: "Ironheart",
    },
    {
        name: "The Inheritors",
        img: "images/modules/mc30_spider-ham_cardsingles__bora.png",
        pack: "Spider-Ham",
    },
    {
        name: "Iron Spider's Sinister Six",
        img: "images/modules/mc31_spdr_isss.png",
        pack: "SP//dr",
    },
    {
        name: "Acolytes",
        img: "images/modules/mc32_acolytes.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Brotherhood",
        img: "images/modules/mc32_brotherhood.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Future Past",
        img: "images/modules/mc32_future_past.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Mystique",
        img: "images/modules/mc32_mystique.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Sentinels",
        img: "images/modules/mc32_sentinels.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Zero Tolerance",
        img: "images/modules/mc32_zero_tolerance.png",
        pack: "Mutant Genesis",
    },
    {
        name: "Magneto (campaign cards)",
        img: "images/scenarios/magneto-ally.png",
        pack: "Mutant Genesis",
        randomize: false,
    },
    {
        name: "Deathstrike",
        img: "images/modules/mc35_deathstrike.png",
        pack: "Wolverine",
    },
    {
        name: "Shadow King",
        img: "images/modules/mc36_shadow_king.png",
        pack: "Storm",
    },
    {
        name: "Crime",
        img: "images/modules/mc39_crime.png",
        pack: "MojoMania",
    },
    {
        name: "Fantasy",
        img: "images/modules/mc39_fantasy.png",
        pack: "MojoMania",
    },
    {
        name: "Horror",
        img: "images/modules/mc39_horror.png",
        pack: "MojoMania",
    },
    {
        name: "Sci-Fi",
        img: "images/modules/mc39_scifi.png",
        pack: "MojoMania",
    },
    {
        name: "Sitcom",
        img: "images/modules/mc39_sitcom.png",
        pack: "MojoMania",
    },
    {
        name: "Western",
        img: "images/modules/mc39_western.png",
        pack: "MojoMania",
    },
    {
        name: "Exodus",
        img: "images/modules/exodus.jpg",
        pack: "Gambit",
    },
    {
        name: "Reavers",
        img: "images/modules/reavers.jpg",
        pack: "Rogue",
    },
    {
        name: "Black Tom Cassidy",
        img: "images/modules/black-tom-cassidy.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Extreme Measures",
        img: "images/modules/extreme-measures.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Flight",
        img: "images/modules/flight.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Hope Summers",
        img: "images/modules/hope-summers.jpg",
        pack: "NeXt Evolution",
        randomize: false,
    },
    {
        name: "Marauders",
        img: "images/modules/marauders.jpg",
        pack: "NeXt Evolution",
        randomize: false,
    },
    {
        name: "Military Grade",
        img: "images/modules/military-grade.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Mutant Insurrection",
        img: "images/modules/mutant-insurrection.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Mutant Slayers",
        img: "images/modules/mutant-slayers.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Nasty Boys",
        img: "images/modules/nasty-boys.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Super Strength",
        img: "images/modules/super-strength.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Telepathy",
        img: "images/modules/telepathy.jpg",
        pack: "NeXt Evolution",
    },
    {
        name: "Infinites",
        img: "images/modules/mc45_unus_cards_infinitesoldier.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Dystopian Nightmare",
        img: "images/modules/dystopian-nightmare.jpg",
        pack: "Age of Apocalypse"
    },
    {
        name: "Hounds",
        img: "images/modules/mc45_fourhorsemen_cards_ahab.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Prelates",
        img: "images/modules/mc45_apocalypse_cards_mistersinister.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Dark Riders",
        img: "images/modules/mc45_apocalypse_cards_gauntlet.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Savage Land",
        img: "images/modules/mc45_darkbeast_cards_thesavageland.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Genosha",
        img: "images/modules/mc45_darkbeast_cards_genosha.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Blue Moon",
        img: "images/modules/mc45_darkbeast_cards_blueareaofthemoon.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Celestial Tech",
        img: "images/modules/mc45_ensabahnur_cards_celestialarmor.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Clan Akkaba",
        img: "images/modules/mc45_ensabahnur_cards_ozymandias.png",
        pack: "Age of Apocalypse"
    },
    {
        name: "Sauron",
        img: "images/modules/mc46_announce_cards_sauron.png",
        pack: "Iceman"
    },
    {
        name: "Arcade",
        img: "images/modules/mc47_announce_cards_arcade.png",
        pack: "Jubilee"
    },
    {
        name: "Crazy Gang",
        img: "images/modules/mc48_announcement_article_the_crazy_gang_33_card_horizontal.png",
        pack: "Nightcrawler"
    },
    {
        name: "Hellfire",
        img: "images/modules/mc49_announce_cards_sebastianshaw.png",
        pack: "Magneto"
    },
    {
        name: "A.I.M. Abduction",
        img: "images/modules/aim-abduction.jpg",
        pack: "Agents of S.H.I.E.L.D."
    },
    {
        name: "A.I.M. Science",
        img: "images/modules/aim-science.jpg",
        pack: "Agents of S.H.I.E.L.D."
    },
    {
        name: "Batroc's Brigade",
        img: "images/modules/batrocs-brigade.jpg",
        pack: "Agents of S.H.I.E.L.D."
    },
    {
        name: "Scientist Supreme",
        img: "images/modules/scientist-supreme.jpg",
        pack: "Agents of S.H.I.E.L.D."
    },
    {
        name: "Gravitational Pull",
        img: "images/modules/gravitational-pull.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "Hard Sound",
        img: "images/modules/hard-sound.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "Pale Little Spider",
        img: "images/modules/pale-little-spider.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "Power of the Atom",
        img: "images/modules/power-of-the-atom.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "Supersonic",
        img: "images/modules/supersonic.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "The Leaper",
        img: "images/modules/the-leaper.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        types: ["Thunderbolt"]
    },
    {
        name: "S.H.I.E.L.D.",
        img: "images/modules/shield.jpg",
        pack: "Agents of S.H.I.E.L.D."
    },
    {
        name: "S.H.I.E.L.D. Executive Board",
        img: "images/modules/shield-executive-board.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        randomize: false,
    },
    {
        name: "Executive Board Evidence",
        img: "images/modules/executive-evidence-board.jpg",
        pack: "Agents of S.H.I.E.L.D.",
        randomize: false,
    },
    {
        name: "Extreme Risk",
        img: "images/modules/mc51_announce_cards_joystick.png",
        pack: "Black Panther",
        types: ["Thunderbolt"]
    },
    {
        name: "Growing Strong",
        img: "images/modules/mc52_announcement_article_atlas_35.png",
        pack: "Silk",
        types: ["Thunderbolt"]
    },
    {
        name: "Techno",
        img: "images/modules/mc53_announcement_article_fixer_38.png",
        pack: "Falcon",
        types: ["Thunderbolt"]
    },
    {
        name: "Whiteout",
        img: "images/modules/mc54_announce_cards_blizzard.png",
        pack: "Winter Soldier",
        types: ["Thunderbolt"]
    },
    {
        name: "Trickster Magic",
        img: "images/modules/mc55_announce_cards_absorbingman_minion.png",
        pack: "Trickster Takeover"
    },
    {
        name: "Iron Man",
        img: "images/modules/mc56_article_announce_cards_registration_ironman.png",
        pack: "Civil War",
        types: ["Registration Leader"],
        randomize: false
    },
    {
        name: "Captain Marvel",
        img: "images/modules/mc56_article_announce_cards_registration_captainmarvel.png",
        pack: "Civil War",
        types: ["Registration Leader"],
        randomize: false
    },
    {
        name: "Captain America",
        img: "images/modules/mc56_article_announce_cards_resistance_captainamerica.png",
        pack: "Civil War",
        types: ["Resistance Leader"],
        randomize: false
    },
    {
        name: "Spider-Woman",
        img: "images/modules/mc56_article_announce_cards_resistance_spiderwoman.png",
        pack: "Civil War",
        types: ["Resistance Leader"],
        randomize: false
    },
    {
        name: "Cloak & Dagger",
        img: "images/modules/cloak-and-dagger.jpg",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Hell's Kitchen",
        img: "images/modules/hells-kitchen.jpg",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Atlanteans",
        img: "images/modules/atlanteans.jpg",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Namor",
        img: "images/modules/namor.jpg",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "New Avengers",
        img: "images/modules/mc56_article_announce_cards_resistance_falcon.png",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Secret Avengers",
        img: "images/modules/mc56_article_announce_cards_resistance_blackpanther.png",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Spider-Man",
        img: "images/modules/mc56_article_announce_cards_resistance_spider-man.png",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Defenders",
        img: "images/modules/mc56_article_announce_cards_resistance_lukecage.png",
        pack: "Civil War",
        types: ["Resistance"]
    },
    {
        name: "Cape-Killer",
        img: "images/modules/mc56_article_announce_cards_registration_cape-killer.png",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "The Initiative",
        img: "images/modules/mc56_article_announce_cards_registration_docsamson.png",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Maria Hill",
        img: "images/modules/mc56_article_announce_cards_registration_mariahill.png",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Martial Law",
        img: "images/modules/mc56_article_announce_cards_registration_shieldsoldier.png",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Mighty Avengers",
        img: "images/modules/mc56_article_announce_cards_registration_yellowjacket.png",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Heroes for Hire",
        img: "images/modules/heroes-for-hire.jpg",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Paladin",
        img: "images/modules/paladin.jpg",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "Dangerous Recruits",
        img: "images/modules/dangerous-recruits.jpg",
        pack: "Civil War",
        types: ["Registration"]
    },
    {
        name: "All Versus All",
        img: "images/modules/mc59_announce_cards_allversusall.png",
        pack: "Hercules"
    }
];
